module.exports = __webpack_public_path__ + "img/2.cd3f2356.jpg";